import { create } from "zustand";

export const useFeaturesStore = create((set) => ({
  modalDetails: { open: false },
  isGracePeriod: false,
  gracePeriodDays: null,
  isToggled: false,
  handleOpen: () => set({ modalDetails: { open: true } }),
  handleClose: () => set({ modalDetails: { open: false } }),
  handleStoreValChange: (key, val) => set({ [key]: val }),
}));
